import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "search-tabs"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "search-results"
}
const _hoisted_5 = {
  key: 0,
  class: "result-view"
}
const _hoisted_6 = {
  key: 0,
  class: "image-grid"
}
const _hoisted_7 = ["src", "alt", "onClick"]
const _hoisted_8 = {
  ref: "sentinel",
  class: "sentinel"
}
const _hoisted_9 = {
  key: 1,
  class: "results-list"
}
const _hoisted_10 = { class: "result-content" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "result-url" }
const _hoisted_13 = { class: "result-headline" }
const _hoisted_14 = { class: "result-description" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = {
  key: 2,
  class: "pagination"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "page-numbers" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "message-view"
}
const _hoisted_22 = { class: "query-display" }
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullscreenImage = _resolveComponent("FullscreenImage")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'search-centered': !_ctx.hasResults, 'search-top': _ctx.hasResults })
    }, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => _ctx.performSearch(false), ["prevent"])),
        class: "search-form"
      }, [
        _cache[7] || (_cache[7] = _createElementVNode("a", { href: "/" }, [
          _createElementVNode("img", {
            src: "/img/logo_mini.png",
            alt: "Mini Logo",
            class: "mini-logo"
          })
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
          placeholder: "Enter your search query",
          class: "search-input"
        }, null, 512), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("button", {
          type: "submit",
          class: "search-button"
        }, "Search", -1))
      ], 32),
      (_ctx.hasResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchTabs, (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab,
                class: _normalizeClass(['tab-button', { active: _ctx.activeTab === tab }]),
                onClick: () => _ctx.activeTab = tab
              }, _toDisplayString(tab), 11, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.hasResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.responseData.page === 'result')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Search Results", -1)),
                (_ctx.responseData.st === 'images' && _ctx.responseData.result)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseData.result, (result, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "image-item"
                        }, [
                          _createElementVNode("img", {
                            src: result.imgurl,
                            alt: result.title,
                            class: "result-image",
                            onClick: ($event: any) => (_ctx.openFullScreenImage(result))
                          }, null, 8, _hoisted_7)
                        ]))
                      }), 128)),
                      _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                        [_directive_intersect, _ctx.fetchMoreImages]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_FullscreenImage, {
                  image: _ctx.fullScreenImage,
                  "get-next-image": _ctx.getNextImage,
                  "get-previous-image": _ctx.getPreviousImage,
                  onClose: _ctx.closeFullScreenImage,
                  onChangeImage: _ctx.changeFullScreenImage
                }, null, 8, ["image", "get-next-image", "get-previous-image", "onClose", "onChangeImage"]),
                (_ctx.responseData.result && _ctx.responseData.st !== 'images')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseData.result, (result, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "result-item"
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("a", {
                              href: result.click ? `/v1/api/click?${result.click}` : result.url,
                              class: "result-title",
                              target: "_blank"
                            }, _toDisplayString(result.title), 9, _hoisted_11),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(result.url), 1),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(result.headline), 1),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(result.description), 1)
                          ]),
                          (result.photo)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: result.photo,
                                class: "result-photo",
                                alt: result.title
                              }, null, 8, _hoisted_15))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.responseData.pages > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("button", {
                        disabled: _ctx.currentPage === 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1))),
                        class: "page-button"
                      }, " Previous ", 8, _hoisted_17),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNumbers, (page) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: page,
                            onClick: ($event: any) => (_ctx.changePage(page)),
                            class: _normalizeClass(['page-number', { active: page === _ctx.currentPage }])
                          }, _toDisplayString(page == -1 ? "..." : page), 11, _hoisted_19))
                        }), 128))
                      ]),
                      _createElementVNode("button", {
                        disabled: _ctx.currentPage === _ctx.responseData.pages,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1))),
                        class: "page-button"
                      }, " Next ", 8, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.responseData.page === 'normal' ? 'Normal Page' : 'Abuse Detected'), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createTextVNode(" Your search query: \"" + _toDisplayString(_ctx.searchQuery) + "\" ", 1),
                  (_ctx.responseData.page === 'normal')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchQwant && _ctx.searchQwant(...args)))
                        }, "QWANT"),
                        _createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.searchGoogle && _ctx.searchGoogle(...args)))
                        }, "Google"),
                        _createElementVNode("button", {
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.searchBing && _ctx.searchBing(...args)))
                        }, "Bing")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}